export default __webpack_public_path__ + "static/media/GitHub.55ca2802.svg";